<template>
  <b-card no-body>
    <chartjs-component-bar-chart
      :height="400"
      :data="data"
      :options="options"
    />
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCardTitle } from "bootstrap-vue";
import { $themeColors } from "@themeConfig";
import ChartjsComponentBarChart from "./charts-components/chartjsComponentBarChart.vue";

const chartColors = {
  primaryColorShade: "#836AF9",
  yellowColor: "#ffe800",
  successColorShade: "#28dac6",
  warningColorShade: "#ffe802",
  warningLightColor: "#FDAC34",
  infoColorShade: "#299AFF",
  greyColor: "#4F5D70",
  blueColor: "#2c9aff",
  blueLightColor: "#84D0FF",
  greyLightColor: "#EDF1F4",
  tooltipShadow: "rgba(0, 0, 0, 0.25)",
  lineChartPrimary: "#666ee8",
  lineChartDanger: "#ff4961",
  labelColor: "#6e6b7b",
  grid_line_color: "rgba(200, 200, 200, 0.2)",
};

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    ChartjsComponentBarChart,
  },

  data() {
    return {
      options: {
        elements: {
          rectangle: {
            borderWidth: 2,
            borderSkipped: "bottom",
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        legend: {
          display: false,
        },
        tooltips: {
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: chartColors.tooltipShadow,
          backgroundColor: $themeColors.light,
          titleFontColor: $themeColors.dark,
          bodyFontColor: $themeColors.dark,
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: true,
                color: chartColors.grid_line_color,
                zeroLineColor: chartColors.grid_line_color,
              },
              scaleLabel: {
                display: false,
              },
              ticks: {
                fontColor: chartColors.labelColor,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: chartColors.grid_line_color,
                zeroLineColor: chartColors.grid_line_color,
              },
              ticks: {
                stepSize: 100,
                min: 0,
                max: this.computeMax(),
                fontColor: chartColors.labelColor,
              },
            },
          ],
        },
      },
    };
  },
  methods: {
    computeMax() {
      if (this.data.max > 1500) {
        return 2500;
      } else if (this.data.max > 1200) {
        return 1500;
      } else if (this.data.max > 800) {
        return 1200;
      } else if (this.data.max > 500) {
        return 800;
      } else if (this.data.max > 300) {
        return 500;
      } else if (this.data.max > 200) {
        return 300;
      } else if (this.data.max > 100) {
        return 200
      } else if (this.data.max > 50) {
        return 100
      } else {
        return 50
      }
    },
  },
};
</script>
